import React from 'react';
import css from '@/css/module/billing.css';
import flex from '@/css/module/flex.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { successMessage } from '@/features/subscription/components/utils';
import { closeReactModal, openReactModal } from '@/actions';
import AddCardModal from '@/components/billing/stripe/AddCardModal';
import {
  SUBSCRIPTION_TAG,
  subscriptionApi,
} from '@/features/subscription/apiSlice';
import { useAppDispatch } from '@/store/hooks';

export const CardDetails: React.FC<{
  cardShortName: string;
  stripeKey: string;
  onCardShortNameChange: F<string>;
}> = ({ cardShortName, onCardShortNameChange, stripeKey }) => {
  const dispatch = useAppDispatch();

  const cardAdded = (_cardShortName: string) => {
    successMessage('Card added successfully!');
    onCardShortNameChange(_cardShortName);
    dispatch(subscriptionApi.util.invalidateTags([SUBSCRIPTION_TAG]));
  };

  const onAddCard = () => {
    const closeModal = (success: boolean) => (_cardShortName: string) => {
      dispatch(closeReactModal());
      if (success) {
        cardAdded(_cardShortName);
      }
    };
    dispatch(
      openReactModal(
        <AddCardModal
          stripeKey={stripeKey}
          closeModal={closeModal(false)}
          onCardUpdated={closeModal(true)}
        />,
      ),
    );
  };

  return (
    <div className={css.section}>
      <div className={`${flex.row} ${flex.alignItemsStart}`}>
        <div className={css.billingIcon}>
          <FontAwesomeIcon icon="credit-card" />
        </div>
        {cardShortName ? (
          <span className={`${flex.row} ${flex.wrap}`}>
            <b>Payment card: </b>&nbsp;
            {cardShortName.toUpperCase()}&nbsp;&nbsp;
            <span onClick={onAddCard} className="link">
              Edit
            </span>
          </span>
        ) : (
          <div>
            <span onClick={onAddCard} className="link">
              <b>Add card details</b>
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
